<template>
    <div class="trivia-card">
        <TriviaCount :current="current" :total="total" />
        <TriviaTitle :title="title" :selectAll="selectAll" />
        <ol>
            <li v-for="(answer, index) in answers" :key="index">
                <input type="checkbox" :id="answer.key" name="answer" :value="answer.key" v-model="checkedAnswers" />
                <label :for="answer.key">
                    <span :data-key="answer.key">{{ answer.answer }}</span>
                </label>
            </li>
        </ol>

        <NextButton @click.native="checkAnswer"/>
    </div>    
</template>

<script>
import TriviaCount from '@/components/TriviaCount.vue'
import TriviaTitle from '@/components/TriviaTitle.vue'
import NextButton from '@/components/NextButton.vue'
// import CheckButton from '@/components/CheckButton.vue'

export default {
    name: 'trivia-card',
    props: ['currentTrivia', 'title', 'answers', 'correctAnswer', 'current', 'nextRoute', 'total', 'selectAll', 'className'],
    data() {
        return {
            showCorrect: false,
            correct: false,
            checkedAnswers: [],
            correctAnswers: [],
        }
    },
    components: {
        TriviaCount,
        TriviaTitle,
        NextButton,
        // CheckButton
    },
    methods: {
        checkAnswer() {
            let corrAnswers = JSON.stringify(this.correctAnswer.sort().join())
            let chkAnswers = JSON.stringify(this.checkedAnswers.sort().join())

            this.correct = corrAnswers === chkAnswers
            // this.showCorrect = !this.showCorrect

            let count = this.checkedAnswers.sort().filter(x => this.correctAnswer.sort().includes(x)).length
            let score = parseInt(count * 17)
            let answer = { correct: this.correct,
                            checkedAnswers: this.checkedAnswers.sort().join(', '), 
                            current: this.current, 
                            correctAnswers: this.correctAnswers,
                            correctAnswer: this.correctAnswer,
                            total: this.total,
                            title: this.title,
                            nextRoute: this.nextRoute,
                            className: this.className }

            if(this.correct) {
                score = score + 25
            }

            this.$store.dispatch('incrementScore', { score: score })
            this.$store.dispatch('setCurrentTrivia', { currentTrivia: this.currentTrivia + 1})
            this.$store.dispatch('setCurrentAnswer', { answer: answer })

            this.$router.push({ name: 'trivia-answers' })

        }
    },
    created() {
        this.correctAnswers = this.answers.filter((obj) => {
            return this.correctAnswer.includes(obj.key)
        })
    },
}
</script>

<style lang="scss" scoped>
body {
    background: #4a4a4a;
}

.trivia-card {
    background: #fff;
    bottom: 0;
    box-sizing: border-box;
    height: 98%;
    left: 50%;
    padding: 30px 50px;
    position: fixed;
    transform: translate(-50%);
    width: 98%;

    .hide {
        display: none;
    }

    .show {
        display: block;
    }

    h1 {
        line-height: 35px;
        padding-right:50px;
    }
    .correct-answer {
        color: #666;
        font-family: "Roboto Condensed", sans-serif;
        font-size: 36px;
        font-weight: 200;
        margin: 0 0 15px;
        padding-right: 50px;

        &.multiple {
            font-size: 22px;
        }
    }

    .correct {
        background: #31A508;
        border-radius: 3px 0 0 3px;
        color: #fff;
        padding: 2px 6px 1px;
    }

    .incorrect {
        background: #DE4300;
        border-radius: 3px 0 0 3px;
        color: #fff;
        padding: 2px 6px 1px;
    }

    .answer-back {
        background: #EDE9E9;
        color: #7B7B7B;
        font-weight: bold;
        padding: 2px 6px 1px;
    }

    p {
        color: #4A4A4A;
        font-family: 'Roboto Condensed', sans-serif;
        font-size: 18px;
        text-align: left;
    }

    ol {
        list-style-type: upper-latin;
        padding-left: 25px;
        width: 85%;

        li {
            color: #525252;
            font-size: 18px;
            line-height: 20px;
            margin-bottom: 10px;
            text-align: left;

            input {
                display: none;
            }

            input:checked + label {
                border-bottom: 2px solid #F98B02;
            }

            label {
                border-bottom: 2px solid #ccc;
                display: block;
                width: 100%;
                padding-bottom: 10px;
                padding-left: 25px;
                margin-left: -23px;
            }

            &:hover,
            label {
                cursor: pointer;
            }
        }
    }
}

</style>
